import SkeletonWrap from '@bridebook/web/components/bbcommon/skeleton/skeleton-wrap';
import componentStyles from '@bridebook/web/components/search/search-desktop/skeletons/map-skeleton.style';

export const MapSkeleton = () => {
  const styles = componentStyles();
  return <SkeletonWrap style={styles.wrapper} />;
};
